import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Alert } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  root: {
    margin: '0 auto 30px auto',
    width: '60%',
    [theme.breakpoints.down('lg')]: {
      width: '80%'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}));


/** 
 * 提示框（靜態）
 * type = error    紅
 * type = warning  橘
 * type = info     藍
 * type = success  綠
 */
export function AlertStatic({type, data}){

  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Alert variant='filled' severity={type}>{data}</Alert>
    </Box>
  )
}